<template>
  <ProfileBody/>
</template>

<script>
// @ is an alias to /src
import ProfileBody from '@/components/ProfileBody.vue'

export default {
  name: 'ProfileView',
  components: {
    ProfileBody
  }
}
</script>
